"use client"

import { useState, useEffect } from "react"
import Modal from "../modules/Modal/Moadal"
import Input from "../modules/Input/Input"
import Button from "../modules/Button/Button"

const EditSupplyForm = ({ supply, isOpen, onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    caseManager: "",
    typeOfSupply: "",
    itemName: "",
    location: "",
    status: "",
    quantity: "",
  })
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (supply) {
      setFormData({
        caseManager: supply.caseManager || "",
        typeOfSupply: supply.typeOfSupply || "",
        itemName: supply.itemName || "",
        location: supply.location || "",
        status: supply.status || "",
        quantity: supply.quantity || "",
      })
    }
  }, [supply])

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({ ...prev, [name]: value }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!onSubmit) return
    try {
      setLoading(true)
      await onSubmit(formData)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={supply ? "Edit Supply" : "Add Supply"}
      width="700px"
      height="auto"
      footer={
        <div style={{ display: "flex", gap: "12px", justifyContent: "flex-end" }}>
          <Button variant="secondary" onClick={onClose} disabled={loading}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSubmit} loading={loading}>
            {supply ? "Update Supply" : "Add Supply"}
          </Button>
        </div>
      }
    >
      <form onSubmit={handleSubmit}>
        {/* Row 1 */}
        <div style={{ display: "flex", gap: "16px" }}>
          <Input
            label="Case Manager"
            name="caseManager"
            value={formData.caseManager}
            onChange={handleChange}
            disabled
          />
          <Input
            label="Type of Supply"
            name="typeOfSupply"
            value={formData.typeOfSupply}
            onChange={handleChange}
            disabled
          />
        </div>

        {/* Row 2 */}
        <div style={{ display: "flex", gap: "16px" }}>
          <Input
            label="Item Name"
            name="itemName"
            value={formData.itemName}
            onChange={handleChange}
            disabled
          />
          <Input
            label="Location"
            name="location"
            value={formData.location}
            onChange={handleChange}
            disabled
          />
        </div>

        {/* Row 3 */}
        <div style={{ display: "flex", gap: "16px" }}>
          <Input
            label="Status"
            name="status"
            value={formData.status}
            onChange={handleChange}
          />
          <Input
            label="Quantity"
            name="quantity"
            type="number"
            value={formData.quantity}
            onChange={handleChange}
          />
        </div>
      </form>
    </Modal>
  )
}

export default EditSupplyForm
